import { useView } from '@10000/react'
import { Table } from './table'
import { country as countries, levels, roles } from '../../../lookups'

export const TeamTable = () => {
  const { organisations = [], teams } = useView('tenant')

  const columns = [
    { key: 'name', name: 'Name' },
    { key: 'country', name: 'Country' },
    { key: 'city', name: 'City' },
    { key: 'level', name: 'Level' },
    { key: 'role', name: 'Role' },
    { key: 'organisation', name: 'Organisation' },
    { key: 'leaders', name: 'Leaders' },
  ]

  const rows = teams.map(({ name, city, country, level, role, leaders, organisation }) => ({
    name: name || 'Not found',
    city: city || 'Not found',
    country: countries?.name[country] || 'Not found',
    level: levels[level]?.name || 'Not found',
    role: roles[role]?.name || 'Not found',
    organisation: organisations.find(x => x.id === organisation)?.name || 'N/A',
    leaders: leaders.length || 'Not found',
  }))

  return (
    <Table
      title="Teams"
      rows={rows}
      columns={columns}
      defaultSortColumn="name"
    />
  )
}